import { UserOutlined, FundProjectionScreenOutlined, LogoutOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown, Layout } from 'antd';

import { ENVS } from '@/shared/consts';
import { removeTokens } from '@/shared/helpers';

import styles from './Header.module.scss';

export const Header = () => {
  const items: MenuProps['items'] = [
    {
      key: '1',
      icon: <FundProjectionScreenOutlined />,
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={ENVS.PUBLIC_URL}
        >
          Школа Цифровых Ролей
        </a>
      ),
    },
    {
      key: '2',
      icon: <LogoutOutlined />,
      label: (
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault();

            removeTokens();

            window.location.replace(ENVS.PUBLIC_LOGOUT_URL);
          }}
        >
          Выход
        </a>
      ),
    },
  ];

  return (
    <Layout.Header className={styles.header}>
      <Dropdown menu={{ items }}>
        <Avatar
          size={40}
          icon={<UserOutlined />}
          className={styles.avatar}
        />
      </Dropdown>
    </Layout.Header>
  );
};
